import axios from "axios";

export async function getRaffles() {
    return axios.get(`${process.env.REACT_APP_API_URL}/raffles`);
}
